module.exports = __webpack_public_path__ + "static/media/carouselLeft.b7016ed6.svg";